import { API_REQUEST_PREFIX } from '@shared/config/api/api-prefixes';
import {
    RemoveUserRequestFromOrderDataRequest,
    RemoveUserRequestFromOrderDataResponse,
} from './decline-employee-request-in-order-types';
import { orderApi } from '@entities/order/api/order-api';
import { requestBaseApi } from '@entities/request/api/base';

export const createEmployeeRequestInOrderApi = requestBaseApi.injectEndpoints({
    endpoints: (build) => ({
        removeUserRequestFromOrder: build.mutation<
            RemoveUserRequestFromOrderDataResponse,
            RemoveUserRequestFromOrderDataRequest
        >({
            query: ({ data }) => {
                return {
                    url: `${API_REQUEST_PREFIX}/${data.id}/reject`,
                    method: 'POST',
                    body: { comment: data.comment },
                };
            },
            async onQueryStarted({ optimisticData }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        orderApi.util.updateQueryData('order', optimisticData.orderId, (order) => {
                            const newRequests = order.requests.filter(
                                (request) => request.id !== optimisticData.requestId
                            );
                            return {
                                ...order,
                                requests: newRequests,
                            };
                        })
                    );
                } catch (err) {
                    // patchResult.undo();
                }
            },
        }),
    }),
});

export const { useRemoveUserRequestFromOrderMutation } = createEmployeeRequestInOrderApi;
